import React, { useEffect, useState } from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  CircularProgress,
  Alert,
  Button,
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import ReportDataService from '../../../services/report.service';
import { useTranslation } from '../../../hooks/useTranslation';
import { formatCurrencySync } from '../../../utils/currencyUtils';

const PaymentsIncomeByDateRangeReport = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [data, setData] = useState(null);
  const [startDate, setStartDate] = useState(dayjs().subtract(30, 'day'));
  const [endDate, setEndDate] = useState(dayjs());

  const load = async () => {
    try {
      setLoading(true);
      setError('');
      const params = {};
      if (startDate) params.start_date = startDate.format('YYYY-MM-DD');
      if (endDate) params.end_date = endDate.format('YYYY-MM-DD');
      const res = await ReportDataService.getPaymentsIncomeByDateRange(params);
      setData(res.data?.data || null);
    } catch (e) {
      setError(e.response?.data?.message || t('reports.errorLoading'));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box>
      <Typography variant="h6" fontWeight={800} sx={{ mb: 1 }}>
        {t('reports.paymentsIncomeByDateRange')}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        {t('reports.paymentsIncomeByDateRangeDescription')}
      </Typography>

      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

      <Card variant="outlined" sx={{ mb: 2 }}>
        <CardContent>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', alignItems: 'center', mb: 2 }}>
              <DatePicker
                label={t('reports.startDate')}
                value={startDate}
                onChange={(v) => setStartDate(v)}
              />
              <DatePicker
                label={t('reports.endDate')}
                value={endDate}
                onChange={(v) => setEndDate(v)}
              />
              <Button variant="contained" onClick={load} disabled={loading}>
                {t('reports.filter')}
              </Button>
            </Box>
          </LocalizationProvider>

          {loading ? (
            <Box display="flex" justifyContent="center" py={4}><CircularProgress /></Box>
          ) : (
            <>
              <Typography variant="h6" fontWeight={800} sx={{ mb: 1 }}>
                {t('reports.totalIncome')}: {formatCurrencySync(data?.total_income || 0)}
              </Typography>
            </>
          )}
        </CardContent>
      </Card>
    </Box>
  );
};

export default PaymentsIncomeByDateRangeReport;

